import {
  DeleteOutlined,
  EditOutlined,
  SafetyOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Badge,
  Button,
  Modal,
  Popconfirm,
  Space,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { GENDER, ROLE } from "../../../../constants/common";
import { useState } from "react";
import dayjs from "dayjs";

export function UserList({
  data,
  loading,
  total,
  filter,
  onFilterChange,
  onEdit,
  onDelete,
  user,
  onChangePassword,
}) {
  const [previewImage, setPreviewImage] = useState(null);
  const isAdmin = user?.role === "admin";

  const columns = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: 70,
      align: "center",
      fixed: "left",
    },
    {
      title: "Tên",
      dataIndex: "name",
      key: "name",
      width: 300,
      fixed: "left",
      render: (_, record) => (
        <Space>
          {record.avatar ? (
            <Avatar
              size={40}
              src={record.avatar}
              alt={record.name}
              onClick={() => setPreviewImage(record.avatar)}
            />
          ) : (
            <Avatar size={40}>
              <UserOutlined />
            </Avatar>
          )}
          <div>
            <Typography.Text style={{ display: "block", fontWeight: 600 }}>
              {record.name}
            </Typography.Text>
            <Typography.Text
              style={{ display: "block", fontStyle: "italic", color: "grey" }}
            >
              {record.email}
            </Typography.Text>
          </div>
        </Space>
      ),
    },
    {
      title: "Xác thực email",
      dataIndex: "isVerified",
      key: "isVerified",
      align: "center",
      width: 120,
      render: (isVerified) => (
        <Tag variant="outlined" color={isVerified ? "green" : "red"}>
          {isVerified ? "Đã xác thực" : "Chưa xác thực"}
        </Tag>
      ),
    },
    {
      title: "Pháp danh",
      dataIndex: "buddhistName",
      key: "buddhistName",
      width: 200,
    },
    {
      title: "Giới tính",
      dataIndex: "gender",
      key: "gender",
      align: "center",
      width: 100,
      render: (gender) => (
        <Tag variant="outlined" color="yellow">
          {GENDER[gender]}
        </Tag>
      ),
    },
    {
      title: "Ngày sinh",
      dataIndex: "birthday",
      key: "birthday",
      width: 250,
      render: (birthday) => dayjs(birthday).format("DD/MM/YYYY"),
    },
    {
      title: "Vai trò",
      dataIndex: "role",
      key: "role",
      align: "center",
      width: 200,
      render: (role) => (
        <Tag
          variant="outlined"
          color={
            role === "staff"
              ? "blue"
              : role === "assistant"
                ? "orange"
                : "default"
          }
        >
          {ROLE[role]}
        </Tag>
      ),
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      key: "phone",
      width: 200,
    },
    {
      title: "Địa chỉ",
      dataIndex: "address",
      key: "address",
      width: 250,
    },
    {
      title: "Trạng thái",
      dataIndex: "isActive",
      key: "isActive",
      align: "center",
      width: 120,
      render: (isActive) => (
        <Badge
          status={isActive ? "success" : "error"}
          text={isActive ? "Hoạt động" : "Ngừng hoạt động"}
        />
      ),
    },
    {
      title: "Hành động",
      key: "action",
      width: 120,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space size="small">
          {isAdmin && (
            <Tooltip title="Đổi mật khẩu">
              <Button
                type="text"
                size="small"
                icon={<SafetyOutlined />}
                onClick={() => onChangePassword?.(record)}
                style={{ color: "#faad14" }}
              />
            </Tooltip>
          )}
          <Button
            type="text"
            size="small"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
            style={{ color: "green" }}
          />
          <Popconfirm
            title="Bạn có chắc muốn xóa?"
            onConfirm={() => onDelete(record._id)}
            okText="Có"
            cancelText="Không"
          >
            <Button type="text" danger size="small" icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        scroll={{ x: 1200 }}
        columns={columns}
        dataSource={
          data.length
            ? data.map((item, idx) => ({
                ...item,
                ...(filter && {
                  key: (filter.page - 1) * filter.limit + idx + 1,
                }),
              }))
            : []
        }
        loading={loading}
        rowKey="_id"
        pagination={{
          current: filter.page,
          pageSize: filter.limit,
          total,
          showSizeChanger: true,
          onChange: (page, pageSize) =>
            onFilterChange({ ...filter, page, limit: pageSize }),
        }}
        size="middle"
        bordered
        rowClassName={() => "hover-row"}
      />

      <Modal
        open={!!previewImage}
        title="Ảnh đại diện"
        footer={null}
        onCancel={() => setPreviewImage(null)}
        width={400}
      >
        {previewImage && (
          <img
            src={previewImage}
            alt="Avatar"
            style={{ width: "100%", display: "block" }}
          />
        )}
      </Modal>
    </>
  );
}
